"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
const Adult = props => {
  const {
    fontsize,
    themeColor,
    ...rest
  } = props;
  const theme = _react.default.useContext(_styledComponents.ThemeContext);
  const {
    sizeStyles,
    colorStyles
  } = (0, _inline_svg.parseStyles)({
    fontsize,
    themeColor
  }, theme);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 10 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M4.5834 4.1287C5.83124 4.1287 6.84282 3.20446 6.84282 2.06435C6.84282 0.92424 5.83124 0 4.5834 0C3.33555 0 2.32397 0.92424 2.32397 2.06435C2.32397 3.20446 3.33555 4.1287 4.5834 4.1287Z",
    fill: "#75767A"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M6.52005 5.42578L4.90617 8.13893H4.5834H4.26062L2.64675 5.42578L0 6.48745V13.2113L2.32398 14.391L3.22775 21.9996H4.5834H5.93905L6.84282 14.391L9.1668 13.2113V6.48745L6.52005 5.42578Z",
    fill: "#75767A"
  }, colorStyles)));
};
Adult.propTypes = _inline_svg2.default.propTypes;
Adult.defaultProps = _inline_svg2.default.defaultProps;
var _default = exports.default = Adult;